import { useMemo } from 'react'
import styled from 'styled-components'

import { useAppContext } from '../../hooks/useAppContext'
import { CustomTemplate } from '../../services/models/CustomTemplate.model'
import { ListBox } from './ListBox'
import { Loader } from './Loader'

interface Props {
    templateId?: string
    onChange(templateId: string, isCustomTemplate: boolean): void
}

const Styles = styled.div`
    max-height: 200px;

    .listbox-options {
        max-height: 200px;
    }
`

export const TemplatesListBox = ({ templateId, onChange }: Props) => {
    const { allTemplates, isLoading } = useAppContext().templates

    const options = useMemo(() => {
        return allTemplates.map((template) => {
            return {
                value: template._id,
                displayNode: template.name,
                data: template,
            }
        })
    }, [allTemplates])

    const optionSelected = useMemo(
        () => options?.find((i) => i.value === templateId),
        [templateId, options]
    )

    if (isLoading) {
        return <Loader />
    }

    return (
        <Styles>
            <ListBox
                optionSelected={optionSelected}
                options={options}
                onChange={(option) =>
                    onChange(
                        option.value,
                        (option.data as CustomTemplate).isCustom
                    )
                }
                listBoxOptionsClassname="listbox-options"
            />
        </Styles>
    )
}
